export default [
	{
		text: 'Interested',
		type: 1,
		error: false,
		active: false,
		flag: 'potentialClientNotInterested'
	},
	{
		text: 'Not interested',
		type: 2,
		error: false,
		active: false,
		flag: 'potentialClientOther'
	},
	{
		text: 'Other',
		type: 3,
		error: false,
		active: false,
		flag: 'potentialClientPotential'
	},
	{
		text: 'On-boarded',
		type: 4,
		error: false,
		active: false,
		flag: 'potentialClientInterested'
	}
];
